import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/executive-small.svg";
var ExecutiveSmallOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ExecutiveSmallOutline_default as default
};
